import React from 'react';

import Icon from '@app/component/icon';
import { SILVER_SAND } from '@app/constant/colors';

const NavigationItemBackArrow = () => (
  <Icon className="nav__back-icon" color={SILVER_SAND} type="ArrowCircle" />
);

export default React.memo(NavigationItemBackArrow);
